import { Button } from 'antd'
import EditTeacherButton from './edit-teacher-button.jsx'
import RemoveTeacherButton from './remove-teacher-button.jsx'
import styles from './teacher_page.module.scss'

export const getTeacherTableColumns = ({
  i18n,
  courses,
  isMultiCourse,
  onPasswordReset,
  canWrite = true
}) => {
  const readColumns = [
    {
      title: i18n.t('common.resources.user.attributes.name.label'),
      dataIndex: 'name',
      align: 'center'
    },
    {
      title: i18n.t('common.resources.user.attributes.email.label'),
      dataIndex: 'email',
      align: 'center'
    },
    {
      title: i18n.t('common.resources.course.label', { count: 1 }),
      dataIndex: 'course',
      align: 'center'
    }
  ]

  // FINANCE (read-only): drop the mutation columns entirely (header included)
  // instead of rendering empty cells.
  if (!canWrite) return readColumns

  const writeColumns = [
    {
      title: i18n.t('pages.MySchool.actions'),
      dataIndex: 'actions',
      align: 'center',
      render: (info, user) => {
        const { registrationId } = user
        const isRegistrationId = !!registrationId
        return (
          <div className={styles.actions_buttons_wrapper}>
            <div className={styles.action_wrapper}>
              <EditTeacherButton
                user={user}
                courses={courses}
                isMultiCourse={!!isMultiCourse}
              />
            </div>
            <div className={styles.action_wrapper}>
              {isRegistrationId &&
                (<RemoveTeacherButton
                  isMultiCourse={isMultiCourse}
                  user={user}
                 />
                )}
            </div>
          </div>
        )
      }
    },
    {
      title: i18n.t('common.resources.generic.actions.any.reset').toUpperCase(),
      dataIndex: 'resetPassword',
      align: 'center',

      render: (text, info) => {
        const { email } = info
        return (
          <Button
            style={{ fontWeight: 'bold' }}
            type='primary'
            shape='round'
            onClick={() => onPasswordReset(email)}
          >
            {i18n.t('common.resources.user.attributes.password.label')}
          </Button>
        )
      }
    }
  ]

  return [...readColumns, ...writeColumns]
}
